import { render, staticRenderFns } from "./IconColumn.vue?vue&type=template&id=1f6a561c&scoped=true&lang=pug"
import script from "./IconColumn.vue?vue&type=script&lang=js"
export * from "./IconColumn.vue?vue&type=script&lang=js"
import style0 from "./IconColumn.vue?vue&type=style&index=0&id=1f6a561c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a561c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6a561c')) {
      api.createRecord('1f6a561c', component.options)
    } else {
      api.reload('1f6a561c', component.options)
    }
    module.hot.accept("./IconColumn.vue?vue&type=template&id=1f6a561c&scoped=true&lang=pug", function () {
      api.rerender('1f6a561c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/icon-columns/IconColumn.vue"
export default component.exports